import { render, staticRenderFns } from "./treso-moisson-chip.vue?vue&type=template&id=558377e4&scoped=true"
import script from "./treso-moisson-chip.vue?vue&type=script&lang=js"
export * from "./treso-moisson-chip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558377e4",
  null
  
)

export default component.exports